import React from 'react';
import './Work.css';

const Work = () => {
  return (
    <section
      id="work"
      className="work"
      style={{
        position: 'relative',
        background: '#edf5ff'
      }}
    >
      <div className="section-container">
        <h2 className="section-title">Work Experience</h2>
        <div className="work-timeline">
          <div className="timeline-item timeline-item--note">
            <div className="timeline-dot timeline-dot--note"></div>
            <article className="relocation-card">
              <div className="relocation-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 21s7-5.4 7-11a7 7 0 1 0-14 0c0 5.6 7 11 7 11Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                  <circle cx="12" cy="10" r="2.4" fill="currentColor" />
                </svg>
              </div>
              <div className="relocation-copy">
                <p className="relocation-kicker">August 2026</p>
                <h3 className="relocation-title">Relocated to Paderborn, Germany</h3>
                <p className="relocation-text">
                  Startng a new chapter as I relocated to Paderborn, Germany.
                </p>
              </div>
            </article>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/studo_logo.png" alt="Studo Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>Software Developer</h3>
                  <p className="timeline-institution">
                    <a href="https://studo.com/en" target="_blank" rel="noopener noreferrer">
                      Studo GmbH
                    </a>
                  </p>
                </div>
              </div>
              <p className="timeline-date">October 2023 - August 2026 (Part-time)</p>
              <p className="timeline-description">
                📍 2025-2026: Backend and Support. Focusing on the direct support tickets from our app users and solving issues in the backend (data parsers) of the Studo App.
                <br />
                📍 2023-2025: Continued with web development (with main focus on front-end development).
              </p>
              <div className="work-tags">
                <span className="tag">Kotlin</span>
                <span className="tag">Html & CSS</span>
                <span className="tag">React</span>
                <span className="tag">Javascript</span>
                <span className="tag">Web Development</span>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/studo_logo.png" alt="Studo Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>Software Developer</h3>
                  <p className="timeline-institution">
                    <a href="https://studo.com/en" target="_blank" rel="noopener noreferrer">
                      Studo GmbH
                    </a>
                  </p>
                </div>
              </div>
              <p className="timeline-date">July 2023 - September 2023 (Full-time)</p>
              <p className="timeline-description">
                Full-time web development role using Kotlin, React and JS through Kotlin wrappers. After finishing my internship, I started working on web projects such as Studo Connect website and Flow website. I developed web features both in front-end and back-end but with a focus on front-end.
              </p>
              <div className="work-tags">
                <span className="tag">Kotlin</span>
                <span className="tag">Html & CSS</span>
                <span className="tag">React</span>
                <span className="tag">JavaScript</span>
                <span className="tag">Web Development</span>
              </div>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <img src="/images/studo_logo.png" alt="Studo Logo" className="institution-logo" />
                <div className="timeline-header-text">
                  <h3>Software Development Intern</h3>
                  <p className="timeline-institution">
                    <a href="https://studo.com/en" target="_blank" rel="noopener noreferrer">
                      Studo GmbH
                    </a>
                  </p>
                </div>
              </div>
              <p className="timeline-date">September 2022 - June 2023 (Full-time)</p>
              <p className="timeline-description">
                Internship focused on learning web development. In this period of time, I got my first experience of working in a start-up team and contributed to real-world software features. I learned Kotlin programming language and gained so much experience in front-end development, agile processes and so many different tools.
              </p>
              <div className="work-tags">
                <span className="tag">Kotlin</span>
                <span className="tag">Web Development</span>
                <span className="tag">Internship</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
